// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productImageCarouselStyles } from "@pace/Overrides/Components/ProductImageCarousel";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

const overrideStyles = (isSelected?: boolean) => ({
    css: css`
        border-radius: 4px;
        max-width: 93px;
        max-height: 93px;
        img {
            max-width: 91px;
            max-height: 91px;
            width: 91px;
            height: 91px;
            padding: 0;
            ${xScreen("lt", "sm")} {
                width: 70px;
                height: 70px;
            }
        }
        opacity: ${isSelected ? 1 : 0.5};
        border: ${isSelected ? css`2px solid ${color("primary.main")}` : "none"};
        ${xScreen("lte", "sm")} {
            max-width: 62px;
            max-height: 62px;
            img {
                width: 62px;
                height: 62px;
            }
        }
    `,
});

productImageCarouselStyles.image = overrideStyles();
productImageCarouselStyles.selectedImage = overrideStyles(true);
productImageCarouselStyles.imagesContainer = {
    css: css`
        display: flex;
        gap: 20px;
        justify-content: center;
    `,
};
